import { render, staticRenderFns } from "./CustomsValueHeader.vue?vue&type=template&id=0e146824"
import script from "./CustomsValueHeader.vue?vue&type=script&lang=js"
export * from "./CustomsValueHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports